var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.rm
    ? _c("div", [
        _c(
          "table",
          { staticClass: "table table-bordered" },
          [
            _c(
              "thead",
              {
                staticClass: "table-secondary",
                staticStyle: {
                  "border-collapse": "collapse",
                  "border-left": "5px solid gray",
                },
              },
              [
                _c(
                  "tr",
                  [
                    _c("th", [
                      _vm._v(
                        "All values in: " + _vm._s(_vm.rm.CurrencyLabel) + " "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.rm.Columns, function (c) {
                      return _c("th", [_vm._v(_vm._s(c.Label))])
                    }),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", { staticClass: "table-info" }, [
                          _vm._v("3yr CAGR"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", { staticClass: "table-info" }, [
                          _vm._v("5yr CAGR"),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "tbody",
              { staticClass: "revenues" },
              [
                _c(
                  "tr",
                  [
                    _c("th", [
                      _c(
                        "div",
                        {
                          staticClass: "pointer",
                          on: { click: _vm.toggleRevenues },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "flex-grow": "1",
                              },
                            },
                            [
                              _c("i", {
                                class: [
                                  "fa",
                                  _vm.revenuesCollapsed
                                    ? "fa-chevron-down"
                                    : "fa-chevron-up",
                                ],
                                staticStyle: { "margin-right": "10px" },
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.rm.Revenues.Label) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-muted" }, [
                            _vm._v("% growth"),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.numberOfColumns, function (i) {
                      return _c("th", { key: i }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.rm.Revenues.Values[i - 1]) +
                            "\n                    "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(
                            _vm._s(_vm.rm.Revenues.GrowthPercentages[i - 1])
                          ),
                        ]),
                      ])
                    }),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.rm.Revenues.Cagr3yr) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.rm.Revenues.Cagr5yr) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._l(_vm.rm.Revenues.Accounts, function (r) {
                  return !_vm.revenuesCollapsed
                    ? _c(
                        "tr",
                        { key: r.Id },
                        [
                          _c("td", [
                            _vm._v("\n                    " + _vm._s(r.Label)),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-muted" }, [
                              _vm._v("% growth"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.numberOfColumns, function (i) {
                            return _c("td", { key: i }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(r.Values[i - 1])
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(r.GrowthPercentages[i - 1])),
                              ]),
                            ])
                          }),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(r.Cagr3yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(r.Cagr5yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e()
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "tbody",
              { staticClass: "cogs" },
              [
                _c(
                  "tr",
                  [
                    _c("th", [
                      _c(
                        "div",
                        {
                          staticClass: "pointer",
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "flex-grow": "1",
                          },
                          on: { click: _vm.toggleCogs },
                        },
                        [
                          _c("i", {
                            class: [
                              "fa",
                              _vm.cogsCollapsed
                                ? "fa-chevron-down"
                                : "fa-chevron-up",
                            ],
                            staticStyle: { "margin-right": "10px" },
                          }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.rm.Cogs.Label) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.numberOfColumns, function (i) {
                      return _c("th", { key: i }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.rm.Cogs.Values[i - 1]) +
                            "\n                "
                        ),
                      ])
                    }),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.rm.Cogs.Cagr3yr) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.rm.Cogs.Cagr5yr) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._l(_vm.rm.Cogs.Accounts, function (c) {
                  return !_vm.cogsCollapsed
                    ? _c(
                        "tr",
                        { key: c.Id },
                        [
                          _c("td", [_vm._v(_vm._s(c.Label))]),
                          _vm._v(" "),
                          _vm._l(_vm.numberOfColumns, function (i) {
                            return _c("td", { key: i }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(c.Values[i - 1]) +
                                  "\n                "
                              ),
                            ])
                          }),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(c.Cagr3yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(c.Cagr5yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e()
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(_vm.rm.Cogs.Subtotals, function (sub) {
              return !_vm.cogsCollapsed
                ? _c(
                    "tbody",
                    { key: sub.Id, staticClass: "cogs" },
                    [
                      _c(
                        "tr",
                        [
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "pointer",
                                on: {
                                  click: function ($event) {
                                    sub.IsCollapsed = !sub.IsCollapsed
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      class: [
                                        "fa",
                                        sub.IsCollapsed
                                          ? "fa-chevron-down"
                                          : "fa-chevron-up",
                                      ],
                                      staticStyle: { "margin-right": "10px" },
                                    }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(sub.Label) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.numberOfColumns, function (i) {
                            return _c("td", { key: i }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(sub.Values[i - 1])
                              ),
                              _c("br"),
                            ])
                          }),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(sub.Cagr3yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(sub.Cagr5yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(sub.Accounts, function (e) {
                        return !sub.IsCollapsed
                          ? _c(
                              "tr",
                              { key: e.Id },
                              [
                                _c("td", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(e.Label) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.numberOfColumns, function (i) {
                                  return _c("td", { key: i }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(e.Values[i - 1]) +
                                        "\n                "
                                    ),
                                  ])
                                }),
                                _vm._v(" "),
                                _vm.cagrVisible
                                  ? _c("td", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(e.Cagr3yr) +
                                          "\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.cagrVisible
                                  ? _c("td", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(e.Cagr5yr) +
                                          "\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e()
                      }),
                    ],
                    2
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c("tbody", { staticClass: "gross-margin" }, [
              _c(
                "tr",
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._l(_vm.numberOfColumns, function (i) {
                    return _c("th", { key: i }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.rm.GrossMargin.Values[i - 1])
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(
                          _vm._s(_vm.rm.GrossMargin.PercentageOfSales[i - 1])
                        ),
                      ]),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.cagrVisible
                    ? _c("th", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.rm.GrossMargin.Cagr3yr) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cagrVisible
                    ? _c("th", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.rm.GrossMargin.Cagr5yr) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              { staticClass: "opex" },
              [
                _c(
                  "tr",
                  [
                    _c("th", [
                      _c(
                        "div",
                        {
                          staticClass: "pointer",
                          on: { click: _vm.toggleOpex },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("i", {
                                class: [
                                  "fa",
                                  _vm.opexCollapsed
                                    ? "fa-chevron-down"
                                    : "fa-chevron-up",
                                ],
                                staticStyle: { "margin-right": "10px" },
                              }),
                              _vm._v(
                                "\n                            Opex\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-muted" }, [
                            _vm._v("% of sales"),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.numberOfColumns, function (i) {
                      return _c("th", { key: i }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.rm.Opex.Values[i - 1])
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(_vm.rm.Opex.PercentageOfSales[i - 1])),
                        ]),
                      ])
                    }),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.rm.Opex.Cagr3yr) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.rm.Opex.Cagr5yr) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._l(_vm.rm.Opex.Accounts, function (e) {
                  return !_vm.opexCollapsed
                    ? _c(
                        "tr",
                        { key: e.Id },
                        [
                          _c("td", [
                            _vm._v("\n                    " + _vm._s(e.Label)),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-muted" }, [
                              _vm._v("% of sales"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.numberOfColumns, function (i) {
                            return _c("td", { key: i }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(e.Values[i - 1])
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(e.PercentageOfSales[i - 1])),
                              ]),
                            ])
                          }),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(e.Cagr3yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(e.Cagr5yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e()
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(_vm.rm.Opex.Subtotals, function (sub) {
              return !_vm.opexCollapsed
                ? _c(
                    "tbody",
                    { key: sub.Id, staticClass: "opex" },
                    [
                      _c(
                        "tr",
                        [
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "pointer",
                                on: {
                                  click: function ($event) {
                                    sub.IsCollapsed = !sub.IsCollapsed
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      class: [
                                        "fa",
                                        sub.IsCollapsed
                                          ? "fa-chevron-down"
                                          : "fa-chevron-up",
                                      ],
                                      staticStyle: { "margin-right": "10px" },
                                    }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(sub.Label) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-muted" }, [
                                  _vm._v("% of sales"),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.numberOfColumns, function (i) {
                            return _c("td", { key: i }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(sub.Values[i - 1])
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(sub.PercentageOfSales[i - 1])),
                              ]),
                            ])
                          }),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(sub.Cagr3yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(sub.Cagr5yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(sub.Accounts, function (e) {
                        return !sub.IsCollapsed
                          ? _c(
                              "tr",
                              { key: e.Id },
                              [
                                _c("td", [
                                  _vm._v(
                                    "\n                    " + _vm._s(e.Label)
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-muted" }, [
                                    _vm._v("% of sales"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.numberOfColumns, function (i) {
                                  return _c("td", { key: i }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(e.Values[i - 1])
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(e.PercentageOfSales[i - 1])
                                      ),
                                    ]),
                                  ])
                                }),
                                _vm._v(" "),
                                _vm.cagrVisible
                                  ? _c("td", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(e.Cagr3yr) +
                                          "\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.cagrVisible
                                  ? _c("td", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(e.Cagr5yr) +
                                          "\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e()
                      }),
                    ],
                    2
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c("tbody", { staticClass: "ebita" }, [
              _c(
                "tr",
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._l(_vm.numberOfColumns, function (i) {
                    return _c("th", { key: i }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.rm.EBITA.Values[i - 1])
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm.rm.EBITA.PercentageOfSales[i - 1])),
                      ]),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.cagrVisible
                    ? _c("th", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.rm.EBITA.Cagr3yr) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cagrVisible
                    ? _c("th", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.rm.EBITA.Cagr5yr) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              { staticClass: "other-expenses" },
              [
                _c(
                  "tr",
                  [
                    _c("th", [
                      _c(
                        "div",
                        {
                          staticClass: "pointer",
                          on: { click: _vm.toggleOtherExpenses },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("i", {
                                class: [
                                  "fa",
                                  _vm.otherExpensesCollapsed
                                    ? "fa-chevron-down"
                                    : "fa-chevron-up",
                                ],
                                staticStyle: { "margin-right": "10px" },
                              }),
                              _vm._v(
                                "\n                            Other expenses\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-muted" }, [
                            _vm._v("% of sales"),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.numberOfColumns, function (i) {
                      return _c("th", { key: i }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.rm.OtherExpenses.Values[i - 1])
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(
                            _vm._s(
                              _vm.rm.OtherExpenses.PercentageOfSales[i - 1]
                            )
                          ),
                        ]),
                      ])
                    }),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.rm.OtherExpenses.Cagr3yr) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.rm.OtherExpenses.Cagr5yr) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._l(_vm.rm.OtherExpenses.Accounts, function (e) {
                  return !_vm.otherExpensesCollapsed
                    ? _c(
                        "tr",
                        { key: e.Id },
                        [
                          _c("td", [
                            _vm._v("\n                    " + _vm._s(e.Label)),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-muted" }, [
                              _vm._v("% of sales"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.numberOfColumns, function (i) {
                            return _c("td", { key: i }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(e.Values[i - 1])
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(e.PercentageOfSales[i - 1])),
                              ]),
                            ])
                          }),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(e.Cagr3yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(e.Cagr5yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e()
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(_vm.rm.OtherExpenses.Subtotals, function (sub) {
              return !_vm.otherExpensesCollapsed
                ? _c(
                    "tbody",
                    { key: sub.Id, staticClass: "other-expenses" },
                    [
                      _c(
                        "tr",
                        [
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "pointer",
                                on: {
                                  click: function ($event) {
                                    sub.IsCollapsed = !sub.IsCollapsed
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      class: [
                                        "fa",
                                        sub.IsCollapsed
                                          ? "fa-chevron-down"
                                          : "fa-chevron-up",
                                      ],
                                      staticStyle: { "margin-right": "10px" },
                                    }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(sub.Label) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-muted" }, [
                                  _vm._v("% of sales"),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.numberOfColumns, function (i) {
                            return _c("td", { key: i }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(sub.Values[i - 1])
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(sub.PercentageOfSales[i - 1])),
                              ]),
                            ])
                          }),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(sub.Cagr3yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cagrVisible
                            ? _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(sub.Cagr5yr) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(sub.Accounts, function (e) {
                        return !sub.IsCollapsed
                          ? _c(
                              "tr",
                              { key: e.Id },
                              [
                                _c("td", [
                                  _vm._v(
                                    "\n                    " + _vm._s(e.Label)
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-muted" }, [
                                    _vm._v("% of sales"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.numberOfColumns, function (i) {
                                  return _c("td", { key: i }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(e.Values[i - 1])
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(e.PercentageOfSales[i - 1])
                                      ),
                                    ]),
                                  ])
                                }),
                                _vm._v(" "),
                                _vm.cagrVisible
                                  ? _c("td", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(e.Cagr3yr) +
                                          "\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.cagrVisible
                                  ? _c("td", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(e.Cagr5yr) +
                                          "\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e()
                      }),
                    ],
                    2
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c("tbody", { staticClass: "adjusted-ebita" }, [
              _c(
                "tr",
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _vm._l(_vm.numberOfColumns, function (i) {
                    return _c("th", { key: i }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.rm.AdjustedEBITA.Values[i - 1])
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(
                          _vm._s(_vm.rm.AdjustedEBITA.PercentageOfSales[i - 1])
                        ),
                      ]),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.cagrVisible
                    ? _c("th", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.rm.AdjustedEBITA.Cagr3yr) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cagrVisible
                    ? _c("th", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.rm.AdjustedEBITA.Cagr5yr) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("tbody", { staticClass: "spacer-row" }, [
              _c(
                "tr",
                [
                  _c("th"),
                  _vm._v(" "),
                  _vm._l(_vm.rm.Columns, function (c) {
                    return _c("th")
                  }),
                  _vm._v(" "),
                  _vm.cagrVisible
                    ? _c("th", { staticClass: "table-info" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cagrVisible
                    ? _c("th", { staticClass: "table-info" })
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "thead",
              {
                staticClass: "table-secondary",
                staticStyle: {
                  "border-collapse": "collapse",
                  "border-left": "5px solid gray",
                },
              },
              [
                _c(
                  "tr",
                  [
                    _c("th", [_vm._v("Resources")]),
                    _vm._v(" "),
                    _vm._l(_vm.rm.Columns, function (c) {
                      return _c("th", [_vm._v(_vm._s(c.Label))])
                    }),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", { staticClass: "table-info" }, [
                          _vm._v("3yr CAGR"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cagrVisible
                      ? _c("th", { staticClass: "table-info" }, [
                          _vm._v("5yr CAGR"),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.rm.Resources.Subtotals, function (sub) {
              return _c(
                "tbody",
                { key: sub.Unit, staticClass: "resources" },
                [
                  _c(
                    "tr",
                    [
                      _c("td", [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function ($event) {
                                sub.IsCollapsed = !sub.IsCollapsed
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c("i", {
                                  class: [
                                    "fa",
                                    sub.IsCollapsed
                                      ? "fa-chevron-down"
                                      : "fa-chevron-up",
                                  ],
                                  staticStyle: { "margin-right": "10px" },
                                }),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(sub.Label) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-muted" }, [
                              _vm._v("% growth"),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.numberOfColumns, function (i) {
                        return _c("td", { key: i }, [
                          _vm._v(
                            "\n                    " + _vm._s(sub.Values[i - 1])
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v(_vm._s(sub.GrowthPercentages[i - 1])),
                          ]),
                        ])
                      }),
                      _vm._v(" "),
                      _vm.cagrVisible
                        ? _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(sub.Cagr3yr) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.cagrVisible
                        ? _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(sub.Cagr3yr) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._l(sub.Accounts, function (e) {
                    return !sub.IsCollapsed
                      ? _c(
                          "tr",
                          { key: e.Id },
                          [
                            _c("td", [
                              _vm._v(
                                "\n                    " + _vm._s(e.Label)
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("div", { staticClass: "text-muted" }, [
                                _vm._v("% growth"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.numberOfColumns, function (i) {
                              return _c("td", { key: i }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(e.Values[i - 1])
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(_vm._s(e.GrowthPercentages[i - 1])),
                                ]),
                              ])
                            }),
                            _vm._v(" "),
                            _vm.cagrVisible
                              ? _c("td", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(e.Cagr3yr) +
                                      "\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.cagrVisible
                              ? _c("td", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(e.Cagr5yr) +
                                      "\n                "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e()
                  }),
                ],
                2
              )
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("th", [
      _vm._v("\n                    Gross margin "),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted" }, [_vm._v("% of sales")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("th", [
      _vm._v("\n                    EBITA "),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted" }, [_vm._v("% of sales")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("th", [
      _vm._v("\n                    Adjusted EBITA "),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted" }, [_vm._v("% of sales")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }